(function () {
  "use strict";

  let enviando_formulario = false;

  if ($("#calendar").length > 0) {
    // Variáveis
    const modalComp = "modal-compromisso";
    const $modalComp = $("#" + modalComp);
    const $modalCompTitulo = $modalComp.find(".modal-titulo");
    const $modalCompBtn = $("#btn-form-comp");
    const $formComp = $("#form-compromisso");
    const $formRemComp = $("#form-remove-comp");
    const $campoTitulo = $("#comp_titulo");
    const $campoStatus = $("#comp_status");
    const $campoDataInicial = $("#comp_data-inicial");
    const $campoHorarioInicial = $("#comp_horario-inicial");
    const $campoDataFinal = $("#comp_data-final");
    const $campoHorarioFinal = $("#comp_horario-final");
    const $campoObservacao = $("#comp_observacao");
    const $campoAcao = $("#comp_acao");
    const $campoIdUpdate = $("#comp_id-update");
    const $campoIdRemove = $("#id_remove_comp");
    const $btnRemCompWrap = $(".btn-rem-comp-wrap");
    const $btnFormCompWrap = $(".btn-form-comp-wrap");
    const $statusCoresInput = $("#status_cores");
    let acao;

    // DATEPICKERS
    const datePickerConf = {
      dateFormat: "d/m/Y",
      defaultDate: "today",
      disableMobile: "true",
      locale: flatpickrPtBr,
    };
    const timePickerConf = {
      enableTime: true,
      allowInput: true,
      noCalendar: true,
      dateFormat: "H:i",
      time_24hr: true,
      disableMobile: "false",
      locale: flatpickrPtBr,
    };
    const dataInicialPicker = flatpickr(
      $campoDataInicial.get(0),
      datePickerConf
    );
    const dataFinalPicker = flatpickr($campoDataFinal.get(0), datePickerConf);
    const horarioInicialPicker = flatpickr(
      $campoHorarioInicial.get(0),
      timePickerConf
    );
    const horarioFinalPicker = flatpickr(
      $campoHorarioFinal.get(0),
      timePickerConf
    );

    $(".datepicker").flatpickr({
      dateFormat: "d/m/Y",
      //defaultDate: "today",
      disableMobile: "true",
      locale: flatpickrPtBr,
    });

    // CALENDÁRIO
    const Calendar = FullCalendar.Calendar;
    const calendarEl = document.getElementById("calendar");
    const calendar = new Calendar(calendarEl, {
      locale: "pt-br",
      eventLimit: true,
      plugins: ["interaction", "dayGrid", "timeGrid"],
      header: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay",
      },
      eventClick: function (info) {
        //console.log(info.event);
        const eventObj = info.event;
        const idUpdate = eventObj.id;
        getCompromisso(idUpdate);
      },
      dateClick: function (info) {
        openModalInsert(info.date);
      },
      //editable: true
    });
    calendar.render();

    // Abre o modal para CADASTRO
    const $btnNovoComp = $(".btn-novo-comp");
    $btnNovoComp.on("click", function () {
      openModalInsert(new Date());
    });
    function openModalInsert(dataInicial) {
      acao = "insert";
      $campoAcao.val(acao);
      $campoTitulo.val("");
      $campoDataInicial.val(objToDataBr(dataInicial));
      $campoDataFinal.val(objToDataBr(dataInicial));
      dataInicialPicker.setDate(dataInicial);
      dataFinalPicker.setDate(dataInicial);
      $campoHorarioInicial.val("");
      $campoHorarioFinal.val("");
      $campoObservacao.val("");
      $campoStatus.val("2");
      $campoStatus.trigger("change");
      $modalCompTitulo.text("Novo Compromisso");
      $modalCompBtn.text("Cadastrar");
      horarioInicialPicker.clear();
      horarioFinalPicker.clear();
      $btnRemCompWrap.hide();
      $btnFormCompWrap.removeClass("right").addClass("center");
      openModal(modalComp);
    }

    // Abre o modal para EDIÇÃO
    function openModalUpdate(compromisso) {
      acao = "update";
      $campoAcao.val(acao);
      $modalCompTitulo.text("Editar Compromisso");
      $modalCompBtn.text("Atualizar");
      $campoTitulo.val(compromisso.titulo);
      $campoDataInicial.val(compromisso.data_inicial);
      $campoHorarioInicial.val(compromisso.horario_inicial);
      $campoDataFinal.val(compromisso.data_final);
      $campoHorarioFinal.val(compromisso.horario_final);
      $campoObservacao.val(compromisso.observacao);
      $campoStatus.val(compromisso.status);
      $campoStatus.trigger("change");
      $campoIdUpdate.val(compromisso.id);
      $campoIdRemove.val(compromisso.id);
      dataInicialPicker.setDate(dataToObj($campoDataInicial.val()));
      dataFinalPicker.setDate(dataToObj($campoDataFinal.val()));
      horarioInicialPicker.setDate(compromisso.horario_inicial, false, "H:i");
      horarioFinalPicker.setDate(compromisso.horario_final, false, "H:i");

      $btnRemCompWrap.show();
      $btnFormCompWrap.removeClass("center").addClass("right");
      openModal(modalComp);
    }

    // Abre o modal para edição ao clicar em um compromisso da lista
    $("[data-comp-list-item]").on("click", function (ev) {
      ev.preventDefault();
      getCompromisso($(this).data("comp-list-item"));
    });

    // Formata a data e horário para obj
    function formataData(data, horario) {
      const newData = dataToObj(data);
      newData.setHours(horario.split(":")[0]);
      newData.setMinutes(horario.split(":")[1]);
      return newData;
    }

    // Retorna a cor do status do compromisso
    function getColor(status) {
      const colors = JSON.parse($statusCoresInput.val());
      return colors[status];
    }

    // Adiciona um novo compromisso ao calendário
    function addCompromisso(compromisso) {
      calendar.addEvent({
        id: compromisso.id,
        title: compromisso.titulo,
        start: compromisso.dataInicial,
        end: compromisso.dataFinal,
        color: compromisso.cor,
        allDay: false,
      });
      hideLoading();
      closeModal(modalComp);
      showAlert("Sucesso", "Compromisso adicionado com sucesso.", "success");
      setTimeout(() => {
        location.reload();
      }, 2000);
    }

    // Atualiza um compromisso no calendário
    function updateCompromisso(compromisso) {
      const novoComp = calendar.getEventById(compromisso.id);
      novoComp.setProp("title", compromisso.titulo);
      novoComp.setProp("color", compromisso.cor);
      novoComp.setStart(compromisso.dataInicial);
      novoComp.setEnd(compromisso.dataFinal);
      hideLoading();
      closeModal(modalComp);
      showAlert("Sucesso", "Compromisso atualizado com sucesso.", "success");
      setTimeout(() => {
        location.reload();
      }, 2000);
    }

    // Remove um compromisso do calendário
    function removeCompromisso(id) {
      const remComp = calendar.getEventById(id);
      remComp.remove();
      hideLoading();
      closeModal("modal-confirm-comp");
      closeModal(modalComp);
      showAlert("Sucesso", "Compromisso removido com sucesso.", "success");
      setTimeout(() => {
        location.reload();
      }, 2000);
    }

    // Obtém um compromisso com base no Id
    function getCompromisso(id) {
      $.getJSON(
        $formComp.attr("action") + "?acao=edit&id_update=" + id,
        function (resp) {
          console.log(resp);
          if (resp) {
            if (resp.status == "success") {
              openModalUpdate(resp.compromisso);
            } else {
              showAlert(
                "Erro",
                "Não foi possível realizar essa operação.",
                "error"
              );
            }
          }
        }
      );
    }

    // Carrega os compromissos cadastrados
    function populaCompromissos() {
      const lista = $("#calendar-events").val();
      const listaObj = JSON.parse(lista);
      const count = listaObj.length;
      const novaLista = [];
      if (count > 0) {
        for (let i = 0, n = count; i < n; i++) {
          novaLista.push({
            id: listaObj[i].id,
            title: listaObj[i].titulo,
            start: formataData(
              listaObj[i].data_inicial,
              listaObj[i].horario_inicial
            ),
            end: formataData(listaObj[i].data_final, listaObj[i].horario_final),
            color: getColor(listaObj[i].status),
            allDay: false,
          });
        }
        calendar.addEventSource(novaLista);
      }
    }
    populaCompromissos();

    // Impede que a data final seja menor que a inicial
    $campoDataInicial.on("change", function () {
      if (
        dataToObj($campoDataInicial.val()) > dataToObj($campoDataFinal.val())
      ) {
        $campoDataFinal.val($campoDataInicial.val());
        dataFinalPicker.setDate(dataToObj($campoDataInicial.val()));
      }
    });
    $campoDataFinal.on("change", function () {
      if (
        dataToObj($campoDataInicial.val()) > dataToObj($campoDataFinal.val())
      ) {
        $campoDataInicial.val($campoDataFinal.val());
        dataInicialPicker.setDate(dataToObj($campoDataFinal.val()));
      }
    });

    // Processa o formulário de INSERT/UPDATE
    $formComp.on("submit", function (e) {
      e.preventDefault();
      const cor = getColor($campoStatus.val());
      const dataInicial = formataData(
        $campoDataInicial.val(),
        $campoHorarioInicial.val()
      );
      const dataFinal = formataData(
        $campoDataFinal.val(),
        $campoHorarioFinal.val()
      );
      const compromisso = {
        titulo: $campoTitulo.val(),
        dataInicial: dataInicial,
        dataFinal: dataFinal,
        cor: cor,
      };
      $.ajax({
        url: $formComp.attr("action"),
        type: $formComp.attr("method"),
        data: new FormData($formComp.get(0)),
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
        },
        success: function (response) {
          console.log(response);
          response = JSON.parse(response);
          if (response.status == "success") {
            if (acao == "insert") {
              compromisso.id = response.ultimo_id;
              addCompromisso(compromisso);
            }
            if (acao == "update") {
              compromisso.id = response.update_id;
              updateCompromisso(compromisso);
            }
          } else {
            hideLoading();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          console.log("ajax error response type " + type);
          hideLoading();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
        },
      });
    });

    // Processa o formulário de REMOÇÃO
    $formRemComp.on("submit", function (e) {
      e.preventDefault();
      acao = "delete";
      $.ajax({
        url: $formRemComp.attr("action"),
        type: $formRemComp.attr("method"),
        data: new FormData($formRemComp.get(0)),
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
        },
        success: function (response) {
          console.log(response);
          response = JSON.parse(response);
          if (response.status == "success") {
            removeCompromisso($campoIdRemove.val());
          } else {
            hideLoading();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          console.log("ajax error response type " + type);
          hideLoading();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
        },
      });
    });
  }

  // Novo negócio
  $("#form-cad-negocio").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = form.find("#btn-cad-negocio");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            closeModal("modal-novo-negocio");
            $("#form-cad-negocio .campo").val("");
            showAlert("Sucesso", "Negócio cadastrado com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });

  // Abre o modal para edição do negócio
  $("[data-modal-neg]").on("click", function () {
    const negocio = $(this).data("modal-neg");
    //console.log(negocio);
    $("#neg_titulo-edit").val(negocio.titulo);
    $("#neg_valor-edit").val(negocio.valor);
    $("#neg_nome-edit").val(negocio.nome);
    $("#neg_empresa-edit").val(negocio.empresa);
    $("#neg_email-edit").val(negocio.email);
    $("#neg_telefone-edit").val(negocio.telefone);
    $("#neg_observacao-edit").val(negocio.observacao);
    $("#neg_status-edit").val(negocio.status);
    $("#neg_status-edit").trigger("change");
    $("#id_update-edit").val(negocio.id);
    $("#id_del_neg").val(negocio.id);
    openModal("modal-update-negocio");
  });

  // Atualiza negócio
  $("#form-upd-negocio").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = form.find("#btn-upd-negocio");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            closeModal("modal-update-negocio");
            $("#form-upd-negocio .campo").val("");
            showAlert("Sucesso", "Negócio atualizado com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });

  // Remove negócio
  $("#form-remove-negocio").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = form.find("#btn-del-negocio");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function (data) {
          console.log(data);
          volta_submit();
          if (data == "ok") {
            closeModal("modal-update-negocio");
            closeModal("modal-confirm");
            showAlert("Sucesso", "Negócio removido com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });
})();
